// extracted by mini-css-extract-plugin
module.exports = {"checkmark":"checkbox_checkmark__3cubY","checkbox":"checkbox_checkbox__26Vge","inline":"checkbox_inline__3y4PV","disabled":"checkbox_disabled__PfWac"};